import { DataModelType } from 'frontend/roles/enum/DataModelType'
import { ref } from 'vue'

export function usePinnedColumns(dataModelType: DataModelType) {
  const pinnedColumns = ref<string[]>([])
  const pinnedElements = ref<Array<{ name: string; left: number; right: number }>>([])

  function updatePinnedColumns(columnName: string) {
    if (pinnedColumns.value.includes(columnName)) {
      pinnedColumns.value = pinnedColumns.value.filter(str => str !== columnName)
    } else {
      pinnedColumns.value = pinnedColumns.value.concat([columnName])
    }
  }

  function updatePinnedElements(data: { name: string; left: number; right: number }[]) {
    pinnedElements.value = data
  }

  return { pinnedColumns, updatePinnedColumns, pinnedElements, updatePinnedElements }
}
